import http from "./http";

// Create Customer User Service
function createCustomerUserService(payload : any) {
  return http.post(`${process.env.REACT_APP_BASE_URL}/customer/customer-user`,
    payload.body
   );
}

// get The Customer User Details
function getCustomerUserDetailsService(payload : any) {
  return http.get(`${process.env.REACT_APP_BASE_URL}/customer/customer-user`);
}

function removeCustomerUserService(payload : any) {
  return http.delete(`${process.env.REACT_APP_BASE_URL}/customer/customer-user/${payload.id}`);
}
// Export All Authorized Service Here
export const authorizedUsersService = {
    createCustomerUserService,
    getCustomerUserDetailsService,
    removeCustomerUserService
};